import React from 'react';
import { Tabs as AnnTabs } from '@ann/web-components';
import { DrivesTabsEnum } from '../../enums/drivesTabs';
import { TabsContainer } from './Tabs.styled';

const Tabs = ({ selectedTab, onTabChange }) => {
  return (
    <TabsContainer>
      <AnnTabs
        key={selectedTab}
        defaultIndex={selectedTab}
        size="small"
        onChange={onTabChange}
      >
        <AnnTabs.List>
          <AnnTabs.Tab
            iconLeft="hardDrive2"
            index={DrivesTabsEnum.DRIVES}
            size="medium"
          >
            Drives
          </AnnTabs.Tab>
          <AnnTabs.Tab 
            iconLeft="folder" 
            index={DrivesTabsEnum.MY_WORKSPACE} 
            size="medium"
          >
            My Workspace
          </AnnTabs.Tab>
          <AnnTabs.Tab 
            iconLeft="group" 
            index={DrivesTabsEnum.SHARED_WITH_ME} 
            size="medium"
          >
            Shared with me
          </AnnTabs.Tab>
        </AnnTabs.List>
      </AnnTabs>
    </TabsContainer>
  );
};

export default Tabs;
